import { render, staticRenderFns } from "./EscalaNpass.vue?vue&type=template&id=e82ede20&"
import script from "./EscalaNpass.vue?vue&type=script&lang=js&"
export * from "./EscalaNpass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports